import { z } from "zod";

export const getLastLocationByCompanyVehiclesPayloadSchema = z.object({
  companyUuid: z.uuid(),
  date: z.iso.datetime(),
});

export type GetLastLocationByCompanyVehiclesPayload = z.infer<
  typeof getLastLocationByCompanyVehiclesPayloadSchema
>;
